<template>
  <q-field
    :error="$v.dValue.$error"
    :error-label="mensagemErro"
    :disabled="desabilitar"
    :helper="mensagemAjuda"
    :label="etiqueta"
    class="g-option"
    style="padding-right: 0px;"
  >
    <q-option-group
      :name="name"
      :id="id"
      :type="tipo"
      :options="option"
      :inline="horizontal"
      :disable="desabilitar"
      @change="change"
      @input="atualizarModelo($event)"
      v-bind:value="value"
    />
  </q-field>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'g-option',
  props: {
    // VALUE REPRESENTA O OBJETO REFERENCIADO POR V-MODEL
    value: {
      type: [String, Number, Array],
      default: ''
    },
    etiqueta: {
      type: String,
      default: ''
    },
    validacao: {
      type: String,
      default: ''
    },
    desabilitar: {
      type: [Boolean, String],
      default: false
    },
    mensagemAjuda: {
      type: String,
      default: ''
    },
    tipo: {
      type: String,
      default: 'radio'
    },
    option: {
      type: Array,
      default: () => []
    },
    horizontal: {
      type: Boolean,
      default: true
    },
    change: {
      type: Function,
      default: () => { }
    },
    name: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dValue: this.value,
      mensagemErro: ''
    }
  },
  validations () {
    var dValue = {}
    var validacoes = this.validacao.split('|')
    // AGREGAR A VALIDAÇÃO DE ACORDO COM O QUE É INFORMADO PELO USUÁRIO
    validacoes.forEach(v => {
      v = v.replace(' ', '')
      if (v === 'required') dValue.required = required
    })

    return { dValue }
  },
  methods: {
    validar () {
      // ALTERAR COR DO CAMPO E EXIBIR MENSAGEM DE ERRO, CASO CAMPO INVÁLIDO
      this.$v.dValue.$touch()
      if (this.$v.dValue.required === false) {
        this.mensagemErro = 'Campo obrigatório não informado'
      }
      return !this.$v.dValue.$invalid
    },
    limpar () {
      this.value = null
    },
    atualizarModelo (value) {
      if (!value) value = null
      this.dValue = value
      // Emite o valor do número através do evento de input
      this.$emit('input', value)
    }
  },
  watch: {
    value (value) {
      this.dValue = value
      this.validar()
    }
  },
  mounted () {

  }
}
</script>
